import React from 'react';
import { Cookie } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: 'impressum' | 'datenschutz' | 'agb' | 'nutzungsbedingungen') => void;
  onOpenCookieSettings?: () => void;
}
export function Footer({
  onNavigate,
  onOpenCookieSettings
}: FooterProps) {
  return <footer className="bg-slate-50 border-t border-slate-200 py-16 text-slate-500 text-sm" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-12" data-id="element-105">
          <div data-id="element-106">
            <div className="text-3xl font-serif font-bold text-slate-900 mb-2" data-id="element-107">
              Uro<span className="text-brand-500" data-id="element-108">Nacht</span>
            </div>
            <p className="text-slate-500" data-id="element-109">
              Wissenschaftlich basierte Männerformel zur Unterstützung von
              Schlafkontinuität und normaler Prostatafunktion in der Nacht.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-3 text-base" data-id="element-110">
            <button onClick={() => onNavigate('impressum')} className="hover:text-brand-500 transition-colors text-left" data-id="element-111">
              Impressum
            </button>
            <button onClick={() => onNavigate('datenschutz')} className="hover:text-brand-500 transition-colors text-left" data-id="element-112">
              Datenschutz
            </button>
            <button onClick={() => onNavigate('agb')} className="hover:text-brand-500 transition-colors text-left" data-id="element-113">
              AGB
            </button>
            <button onClick={() => onNavigate('nutzungsbedingungen')} className="hover:text-brand-500 transition-colors text-left" data-id="element-114">
              Nutzungsbedingungen
            </button>
            {onOpenCookieSettings && <button onClick={onOpenCookieSettings} className="hover:text-brand-500 transition-colors text-left flex items-center gap-1.5" data-id="element-115">
                <Cookie className="w-3.5 h-3.5" data-id="element-116" />
                Cookie-Einstellungen
              </button>}
          </div>
        </div>

        <div className="border-t border-slate-200 pt-10 text-center md:text-left" data-id="element-117">
          <p className="mb-6 max-w-3xl leading-relaxed" data-id="element-118">
            Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene
            Ernährung und gesunde Lebensweise. Die angegebenen Mengen beziehen
            sich auf die empfohlene Tagesdosis von 3 Kapseln. Außerhalb der
            Reichweite von Kindern aufbewahren.
          </p>
          <p className="text-slate-400" data-id="element-119">
            &copy; 2025 UroNacht. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>;
}